module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 35
// module chunks = 0